// extracted by mini-css-extract-plugin
export default {"content":"UnavailabilityActionAskComment_content__F+8ug","askIfAssignedWork":"UnavailabilityActionAskComment_askIfAssignedWork__w31bQ"};